<template>
  <v-layout column v-if="previousImage" align-start>
    <img
      :src="getPhotoWithBase64(previousImage.image_thumb)"
      alt="photo"
      class="network-photo"
    />
    <label class="value-field">{{ label }}</label>
  </v-layout>
</template>

<script>
export default {
  name: "NetworkPhotos",
  props: {
    /**
     * Images of the selected object
     */
    previousImage: Object,

    /**
     * Label corresponding to the image
     */
    label: String
  },

  methods: {
    /**
     * Check if the photo is in base64, if not, change the format to base64
     * @param image
     * @returns {string|*}
     */
    getPhotoWithBase64(image) {
      if (
        image.includes("data:image/jpeg;base64,") ||
        image.includes("data:image/png;base64,")
      ) {
        return image;
      } else return "data:image/jpeg;base64," + image;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Network/Forms/_Molecules/NetworkPhotos.vue